module.exports = typeof window == 'object';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-browser.js
// module id = 1244
// module chunks = 1